<styles-smart-table
  [datasource]="tasks.items"
  [showImageCell]="showImage"
  [headerColumns]="['title']"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [showColumnHeaders]="showColumnHeaders"
  matSort
  (matSortChange)="updateSort($event)"
  [matSortActive]="$safeNavigationMigration(buildSort()?.active) ?? ''"
  [matSortDirection]="$safeNavigationMigration(buildSort()?.direction) ?? ''"
>
  <ng-container matColumnDef="title">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="columnBuilder.getAllColumnNames().length || 0"
      [routerLink]="element | findRoute"
    >
      <a [routerLink]="element | findRoute">
        <div class="container h1">
          @if (!(element | hasSubProject)) {
          <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
            {{ element | workSpaceType | spaceTypeIcon }}
          </mat-icon>
          } @if ((element | hasSubProject)) {
          <span class="ellipsis-text">
            @if (showOrgInTitle === true) {
            <span class="organization">
              {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}</span
            >&nbsp;&nbsp;&nbsp;›&nbsp;&nbsp; } {{(element | findProjectHead)?.name }}
          </span>
          } @else {
          <span class="ellipsis-text">
            @if (showOrgInTitle === true) {
            <span class="organization">
              {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}</span
            >&nbsp;&nbsp;&nbsp;<span class="carat">›</span>&nbsp;&nbsp; } {{ (element | findSpace)?.name }}
          </span>
          } @if (!(element | hasSubProject)) {
          <framework-space-chip [spaceType]="element | workSpaceType"></framework-space-chip>
          }
        </div>
        @if ((element | hasSubProject)) {
        <div class="container h2">
          <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
            {{ element | workSpaceType | spaceTypeIcon }}
          </mat-icon>
          <span class="ellipsis-text"> {{ (element | findSpace)?.name }} </span>
          <framework-space-chip [spaceType]="element | workSpaceType"> </framework-space-chip>
        </div>
        }
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="default"
      mat-sort-header
    >
      Name
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      [routerLink]="element | findRoute"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="default"
    >
      <a [routerLink]="element | findRoute">
        <div class="task-box" [ngClass]="{'dark-mode' : selectDarkMode(element)}">
          <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
            {{ $any(element).status | statusCircleIcon}}
          </mat-icon>
          @if (nonMatchingTaskName(element)) {
          <span class="ellipsis-text">{{ element | phaseNamePipe }} </span>
          <mat-icon class="arrow-icon">
            arrow_forward
            <!-- arrow_right -->
          </mat-icon>
          }
          <span class="ellipsis-text"> {{ element.name }} </span>
          @if ($any(element).parent.name.includes('Version') && $any(element).parent.name !== 'Version 1') {
          <mat-chip-set>
            <mat-chip
              >{{ ($any(element).parent.name.includes('Version') && $any(element).parent.name !== 'Version 1') ?
              ($any(element).parent | versionFormatedPipe : false) : undefined }}</mat-chip
            >
          </mat-chip-set>
          }
        </div>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="organization"
      mat-sort-header
    >
      Organization
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      <div class="task-box" [ngClass]="{'dark-mode' : selectDarkMode(element)}">
        @if (element.feedDetails) {
        <styles-icon-value icon="corporate_fare">
          {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
        </styles-icon-value>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner" mat-sort-header>
      Owner
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <div class="task-box" [ngClass]="{'dark-mode' : selectDarkMode(element)}">
        <span class="owner-wrapper">
          <framework-person-image [person]="element.owner" size="30px"></framework-person-image>
          <span class="name">{{ element.owner.name }}</span>
        </span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="date"
      mat-sort-header
      [disabled]="showPlannedDate === false ? null : true"
    >
      Due
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="date">
      <div class="task-box" [ngClass]="{'dark-mode' : selectDarkMode(element)}">
        <styles-icon-value caption="Due date" icon="event">
          {{ $any(element)?.phaseEnd | date : 'mediumDate' }}
        </styles-icon-value>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="plannedDate">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="plannedDate"
      mat-sort-header
      [disabled]="showPlannedDate === true ? null : true"
    >
      Planned
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="plannedDate">
      <div class="task-box" [ngClass]="{'dark-mode' : selectDarkMode(element)}">
        <styles-icon-value caption="Planned date" icon="event">
          {{ $any(element)?.workEnd | date : 'mediumDate' }}
        </styles-icon-value>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="contentType">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      Content Type
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      <div class="task-box" [ngClass]="{'dark-mode' : selectDarkMode(element)}">
        @if (element | contentType) {
        <styles-icon-value caption="Content Type" icon="eco">
          {{ element | contentType }}@if ((element | findSpace).productInstance?.variant) { &nbsp;•&nbsp;{{ (element |
          findSpace).productInstance.variant }} }
        </styles-icon-value>
        } @else { @if ((element | findSpace).productInstance) {
        <styles-icon-value
          caption="Product Type"
          icon="category"
          [matTooltip]="(element | findSpace).productInstance.name + ' - ' + (element | findSpace).productInstance.variant"
        >
          {{ (element | findSpace).productInstance.name }}@if ((element | findSpace).productInstance.variant) {
          &nbsp;•&nbsp;{{ (element | findSpace).productInstance.variant }} }
        </styles-icon-value>
        } }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="units">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="units">Units</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="units">
      <div class="task-box" [ngClass]="{ 'dark-mode': selectDarkMode(element) }">
        @if (element?.units?.totalUnits > 0) {
        <shared-unit-value-icon
          [element]="element"
          [isCore]="element.currency && element.currency.id === 'CoreSmb' && element.units.totalUnits > 0"
        >
          {{element.units?.totalUnits | number : '1.0-2'}}
        </shared-unit-value-icon>
        } @else {
        <!-- -  -->
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="status"
      mat-sort-header
    >
      Status
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <div class="task-box" [ngClass]="{'dark-mode' : selectDarkMode(element)}">
        <framework-work-status-chip
          [workStatus]="$safeNavigationMigration($any(element)?.status)"
        ></framework-work-status-chip>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="actions"></th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="actions">
      <div class="task-box" [ngClass]="{ 'dark-mode': selectDarkMode(element) }">
        @if (element.defaultAction) {
        <framework-action-button [task]="element" [iconSize]="18"> </framework-action-button>
        } @if (($any(element)?.actions)!.length > 0) {
        <framework-listing-action-dropdown
          menu
          level="task"
          [location]="element | moduleTypePipe"
          [masterProject]="element | findMaster"
          [project]="element | findSpace"
          [phase]="element | phasePipe"
          [task]="element"
          [actions]="$safeNavigationMigration($any(element)?.actions)"
        >
        </framework-listing-action-dropdown>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-owner">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-person-image [person]="group.group" size="40px"></framework-person-image>
        {{ group.group.name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-date">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper"><mat-icon>calendar_today</mat-icon>{{group.group | date : 'MMMM y'}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-organization">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <mat-icon>corporate_fare</mat-icon>
        {{ group.group.organizationName || group.group.feedName}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-status">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-work-status-chip [workStatus]="group.group"></framework-work-status-chip>
      </div>
    </td>
  </ng-container>
</styles-smart-table>
